import { createContext, useContext, useRef, type ReactNode, type RefObject } from 'react';

interface RateTypeSelectPortalContextValue {
  portalRef: RefObject<HTMLDivElement | null>;
}

const RateTypeSelectPortalContext = createContext<RateTypeSelectPortalContextValue | null>(null);

export const RateTypeSelectPortalProvider = ({ children }: { children: ReactNode }) => {
  const portalRef = useRef<HTMLDivElement>(null);

  return <RateTypeSelectPortalContext.Provider value={{ portalRef }}>{children}</RateTypeSelectPortalContext.Provider>;
};

export const useRateTypeSelectPortal = () => {
  const context = useContext(RateTypeSelectPortalContext);

  if (!context) {
    throw new Error('useRateTypeSelectPortal must be used within RateTypeSelectPortalProvider');
  }

  return context;
};
